<template>
    <div class="fill-height of-y d-flex flex-column">

        <div v-if="loading" class="d-flex align-center justify-center flex-grow-1">
            <loader :size="60"></loader>
        </div>

        <template v-else>
            <div class="flex-shrink-1 d-flex align-center">
                <v-tabs v-model="tabIndex" centered fixed-tabs class="flex-grow-1">
                    <v-tab>Bins Received With No Pick Record</v-tab>
                    <v-tab>Bins Picked But Not Received</v-tab>
                </v-tabs>
                <v-btn
                        :disabled="false"
                        @click="exportAnomaliesData"
                        color="primary"
                        small
                        :loading="exportingData"
                        class="mx-2"
                >
                    Export
                </v-btn>
            </div>
                <div class="flex-grow-1 of-y d-flex flex-column fill-height" v-if="tabIndex === 0">
                    <div class="of-y d-flex flex-column" style="height: 30%">
                        <div class="d-flex align-center">
                            <v-card-title class="flex-grow-1 flex-equal py-2">
                                Summary
                            </v-card-title>
                            <div class="flex-grow-1 flex-equal pr-2 d-flex align-center">
                                <v-text-field
                                        v-model="search.received.summary"
                                        prepend-icon="mdi-magnify"
                                        label="Search"
                                        single-line
                                        hide-details
                                        class="pa-0 ma-0 flex-grow-1"
                                ></v-text-field>
                            </div>
                        </div>

                        <v-data-table
                                :search="search.received.summary"
                                dense
                                fixed-header
                                height="100%"
                                class="flex-grow-1 of-y"
                                hide-default-footer
                                :headers="headers.received.summary"
                                :items="data.received.summary"
                                :options="{itemsPerPage: data.received.summary.length}"
                        ></v-data-table>
                    </div>
                    <v-divider></v-divider>
                    <div class="of-y d-flex flex-column flex-grow-1 flex-equal">
                        <div class="d-flex align-center">
                            <v-card-title class="flex-grow-1 flex-equal py-2">
                                Detail
                            </v-card-title>
                            <div class="flex-grow-1 flex-equal pr-2">
                                <v-text-field
                                        v-model="search.received.detail"
                                        prepend-icon="mdi-magnify"
                                        label="Search"
                                        single-line
                                        hide-details
                                        class="pa-0 ma-0"
                                ></v-text-field>
                            </div>
                        </div>
                        <v-data-table
                                :search="search.received.detail"
                                dense
                                fixed-header
                                height="100%"
                                class="flex-grow-1 of-y"
                                hide-default-footer
                                :headers="headers.received.detail"
                                :items="data.received.detail"
                                :options="{itemsPerPage: data.received.detail.length}"
                        ></v-data-table>
                    </div>
                </div>
            <div class="flex-grow-1 of-y d-flex flex-column fill-height" v-if="tabIndex === 1">
                <div class="of-y d-flex flex-column" style="height: 30%">
                    <div class="d-flex align-center">
                        <v-card-title class="flex-grow-1 flex-equal py-2">
                            Summary
                        </v-card-title>
                        <div class="flex-grow-1 flex-equal pr-2 d-flex align-center">
                            <v-text-field
                                    v-model="search.picked.summary"
                                    prepend-icon="mdi-magnify"
                                    label="Search"
                                    single-line
                                    hide-details
                                    class="pa-0 ma-0 flex-grow-1"
                            ></v-text-field>
                        </div>
                    </div>

                    <v-data-table
                            :search="search.picked.summary"
                            dense
                            fixed-header
                            height="100%"
                            class="flex-grow-1 of-y"
                            hide-default-footer
                            :headers="headers.picked.summary"
                            :items="data.picked.summary"
                            :options="{itemsPerPage: data.picked.summary.length}"
                    ></v-data-table>
                </div>
                <v-divider></v-divider>
                <div class="of-y d-flex flex-column flex-grow-1 flex-equal">
                    <div class="d-flex align-center">
                        <v-card-title class="flex-grow-1 flex-equal py-2">
                            Detail
                        </v-card-title>
                        <div class="flex-grow-1 flex-equal pr-2">
                            <v-text-field
                                    v-model="search.picked.detail"
                                    prepend-icon="mdi-magnify"
                                    label="Search"
                                    single-line
                                    hide-details
                                    class="pa-0 ma-0"
                            ></v-text-field>
                        </div>
                    </div>
                    <v-data-table
                            :search="search.picked.detail"
                            dense
                            fixed-header
                            height="100%"
                            class="flex-grow-1 of-y"
                            hide-default-footer
                            :headers="headers.picked.detail"
                            :items="data.picked.detail"
                            :options="{itemsPerPage: data.picked.detail.length}"
                    ></v-data-table>
                </div>
            </div>
        </template>
    </div>
</template>

<script>

import {mapGetters} from "vuex";
import {format} from "date-fns";
import Loader from "../General/Loader/Loader";

export default {
    components: {Loader},
    props: {
        selectedFarm: Number,
        selectedDate: Date
    },
    data() {
        return {

            headers: {
                received: {
                    summary: [
                        {text: "Farm", value: "farmName"},
                        {text: "Total", value: "binsWithNoPickRecord"},
                    ],
                    detail: [
                        {text: "Farm", value: "farmName"},
                        {text: "Captured", value: "capturedStr"},
                        {text: "Bin No", value: "barcode"},
                        {text: "Device", value: "deviceName"},
                    ],
                },
                picked: {
                    summary: [
                        {text: "Farm", value: "farmName"},
                        {text: "Block", value: "blockName"},
                        {text: "Total", value: "binsNotRecieved"},
                    ],
                    detail: [
                        {text: "Farm", value: "farmName"},
                        {text: "Block", value: "blockName"},
                        {text: "Captured", value: "capturedStr"},
                        {text: "Bin No", value: "barcode"},
                        {text: "Emp Codes", value: "empCodes"},
                    ],
                },
            },

            search: {
                received: {
                    summary: null,
                    detail: null,
                },
                picked: {
                    summary: null,
                    detail: null,
                }
            },

            data: {
                received: {
                    summary: [],
                    detail: [],
                },
                picked: {
                    summary: [],
                    detail: [],
                }
            },
            loading: false,
            exportingData: false,
            tabIndex: 0
        }
    },
    watch: {
        selectedFarm: {
            immediate: true,
            handler() {
                this.getAnomaliesData()
            }
        },
        selectedDate(val) {
            if (val) {
                this.getAnomaliesData()
            }
        }
    },
    methods: {
        async getAnomaliesData() {
            try {
                this.loading = true;
                this.data = await this.$newReq(
                        'POST',
                        `reports/binTraceAnomalies`,
                        {
                            date: this.selectedDate,
                            farms: this.selectedFarm ? [this.selectedFarm] : this.availableFarmIDs,
                        },
                )
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError();
            } finally {
                this.loading = false
            }
        },
        exportAnomaliesData() {
            this.exportingData = true;
            this.$newReqDownloadFile(
                    'POST',
                    `reports/binTraceAnomalies/export`,
                    {
                        start: this.selectedDate,
                        farms: this.selectedFarm ? [this.selectedFarm] : this.availableFarmIDs,
                    },
                    `Bin Anomalies Report ${format(this.selectedDate, 'yyyy-MM-dd')}.xlsx`
            )
                    .then(() => {})
                    .catch(e => {
                        console.log(e)
                        this.$snack.netWorkError();
                    })
                    .finally(() => {
                        this.exportingData = false
                    })
        }
    },
    computed: {
        ...mapGetters(['farmsRef', 'availableFarms']),
        availableFarmIDs() {
            return (this.availableFarms.length ? this.availableFarms : this.farms).map((farm) => farm.id)
        },
        farm() {
            return this.selectedFarm ? this.farmsRef[this.selectedFarm] : null
        },
        summary() {
            return [...this.data.summary].sort((a, b) => a.farmDescription > b.farmDescription ? 1 : -1)
        },
        detail() {
            return [...this.data.detail].sort((a, b) => a.binPicked > b.binPicked ? 1 : -1)
        }
        // rows() {
        //     return this.data.map(row => {
        //         return {
        //             farmID: row.farm.id,
        //             farm: row.farm.description,
        //             employee: row.emp.fullName,
        //             empCode: row.emp.empCode,
        //             clockIn: row.clockInStr,
        //             lastAction: row.lastActionStr,
        //             binUnits: row.binUnits,
        //             piecework: row.pieceWorkStr,
        //             pWUnits: row.pieceWorkUnits,
        //             hours: row.hours,
        //         }
        //     }).filter((row) => this.selectedFarm ? row.farmID === this.selectedFarm : true)
        // }
    },
}
</script>

<style scoped>

</style>